import { render } from "./MTProxy.vue?vue&type=template&id=4e895ac2"
import script from "./MTProxy.vue?vue&type=script&lang=js"
export * from "./MTProxy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__